module.exports = __webpack_public_path__ + "img/icn-spec__controller--joyConHorizontal.ec87ad0c.svg";